const emoji = document.querySelector('.emoji-btn');


export function addHandlerOnEmoji() {
  if (emoji === null) {
    return;
  }

  const firstInput = emoji.querySelector('.emoji-btn__input');
  let defaultId = firstInput.id;

  emoji.addEventListener('click', emojiChangeHandler);

  function emojiChangeHandler(evt) {
    evt.preventDefault();

    if (evt.target.closest('label')) {
      const label = evt.target;
      const input = label.control;
      let currentId = input.id;

      if (defaultId === currentId) {
        firstInput.checked = true;
        defaultId = firstInput.id;
      } else {
        input.checked = true;
        defaultId = currentId;
      }

    }
  }
}
